export * from "/__w/wiggot-web/wiggot-web/packages/web-components/components/errors-pages/Error503.tsx"